let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a3g5A")).then(() => parcelRequire('btf6t'));